const exactDollars = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

/** Prices from the automations API are integer USD cents and keep them ($191.90). */
export const formatPriceCents = (cents: number): string =>
  exactDollars.format(cents / 100);
